import React from "react";
import { HiFolder, HiOutlineDotsVertical, HiCalendar, HiOutlineShare } from "react-icons/hi";
import { motion } from "framer-motion";

const FolderCard = ({ folder, onClick, view = "grid", isBig = false, onRename, onShare }) => {
  const date = new Date(folder.createdAt).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric"
  });

  if (view === "list") {
    return (
      <motion.div
        layout
        whileHover={{ x: 10, backgroundColor: "rgba(255,255,255,1)" }}
        onClick={onClick}
        className="flex items-center justify-between p-4 bg-white/60 backdrop-blur-md rounded-xl border border-slate-100 shadow-sm transition-all cursor-pointer group mb-1"
      >
        <div className="flex items-center gap-4 flex-1">
          <div className="w-10 h-10 rounded-xl bg-amber-100 flex items-center justify-center text-amber-500 shadow-inner group-hover:bg-amber-500 group-hover:text-white transition-all duration-300">
            <HiFolder size={20} />
          </div>
          <div>
            <h4 className="font-bold text-slate-700 tracking-tight">{folder.name}</h4>
             <p className="text-[10px] text-slate-400 font-bold uppercase md:hidden">{folder.itemCount || 0} items</p>
          </div>
        </div>
        
        <div className="hidden md:flex flex-1 items-center gap-2 text-xs font-bold text-slate-400 uppercase tracking-widest">
           <HiCalendar size={14} className="text-slate-300" />
           {date}
        </div>

        <div className="flex items-center gap-2">
           <button 
             onClick={(e) => { e.stopPropagation(); onShare(folder); }}
             className="p-2 hover:bg-slate-100 rounded-lg text-slate-400 opacity-0 group-hover:opacity-100 transition-opacity hover:text-indigo-600"
             title="Share"
           >
             <HiOutlineShare size={18} />
           </button>
           <button 
             onClick={(e) => { e.stopPropagation(); onRename(folder); }}
             className="p-2 hover:bg-slate-100 rounded-lg text-slate-400 opacity-0 group-hover:opacity-100 transition-opacity hover:text-indigo-600"
             title="Rename"
           >
            <HiOutlineDotsVertical />
          </button>
        </div>
      </motion.div>
    );
  }

  return (
    <motion.div
      layout
      whileHover={{ y: -8, scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      onClick={onClick}
      className={`relative glass-card-premium overflow-hidden cursor-pointer group flex flex-col ${isBig ? "rounded-[3rem] p-8" : "p-4 rounded-2xl border-white/40 shadow-sm"}`}
    >
      <div className={`flex items-center ${isBig ? "flex-col text-center" : "gap-4"} mb-2`}>
        <div className={`${isBig ? "w-24 h-24 mb-6" : "w-12 h-12"} rounded-2xl bg-gradient-to-br from-amber-50 to-amber-100 flex items-center justify-center text-amber-500 shadow-inner group-hover:from-amber-500 group-hover:to-orange-500 group-hover:text-white transition-all duration-500 lg:group-hover:rotate-12`}>
          <HiFolder size={isBig ? 48 : 28} />
        </div>
        
        <div className="overflow-hidden w-full">
          <h4 className={`${isBig ? "text-xl mb-2" : "text-sm"} font-bold text-slate-700 truncate tracking-tight`}>
            {folder.name}
          </h4>
          <div className={`flex items-center ${isBig ? "justify-center" : ""} gap-1.5`}>
            {!isBig && <span className="text-slate-300 text-[8px]">•</span>}
            <span className={`${isBig ? "hidden" : "block"} text-[10px] text-slate-400 font-bold uppercase tracking-widest`}>
              {date}
            </span>
          </div>
        </div>
      </div>

      <div className="absolute top-4 right-4 flex gap-1">
        <button 
          onClick={(e) => { e.stopPropagation(); onShare(folder); }}
          className="p-2 hover:bg-white/60 rounded-xl text-slate-400 opacity-0 group-hover:opacity-100 transition-all duration-300 hover:text-indigo-600"
          title="Share"
        >
          <HiOutlineShare size={isBig ? 24 : 18} />
        </button>
        <button 
          onClick={(e) => { e.stopPropagation(); onRename(folder); }}
          className="p-2 hover:bg-white/60 rounded-xl text-slate-400 opacity-0 group-hover:opacity-100 transition-all duration-300 hover:text-indigo-600"
          title="Rename"
        >
          <HiOutlineDotsVertical size={isBig ? 24 : 18} />
        </button>
      </div>

      {isBig && (
         <div className="mt-8 pt-8 border-t border-slate-100 w-full flex justify-between items-center">
            <div className="flex -space-x-2">
               {[1,2,3].map(i => (
                 <div key={i} className="w-8 h-8 rounded-full border-2 border-white bg-slate-200" />
               ))}
            </div>
            <span className="text-[11px] font-black text-indigo-600 bg-indigo-50 px-3 py-1.5 rounded-xl uppercase">
               Shared
            </span>
         </div>
      )}
    </motion.div>
  );
};

export default FolderCard;
